// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"cecc5766","453":"36801920","796":"0ba2793f"}[chunkId] + ".chunk.js";
};